import React from 'react';
import Icon from '../../../components/AppIcon';
import { SocialLink } from '../types';

interface SocialLinksProps {
  socialLinks: SocialLink[];
  className?: string;
}

const SocialLinks = ({ socialLinks, className = '' }: SocialLinksProps) => {
  const getPlatformColor = (platform: string) => {
    const colors: Record<string, string> = {
      linkedin: 'hover:bg-blue-600',
      github: 'hover:bg-gray-800',
      twitter: 'hover:bg-blue-400',
      instagram: 'hover:bg-pink-600',
      dribbble: 'hover:bg-pink-500',
      behance: 'hover:bg-blue-500',
      youtube: 'hover:bg-red-600',
      facebook: 'hover:bg-blue-700'
    };
    return colors[platform.toLowerCase()] || 'hover:bg-accent';
  };

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      {socialLinks.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`group relative w-12 h-12 bg-muted rounded-full flex items-center justify-center transition-smooth hover:scale-110 hover:shadow-lg ${getPlatformColor(link.platform)}`}
          aria-label={`Visit ${link.platform} profile`}
        >
          <Icon 
            name={link.icon} 
            size={20} 
            className="text-text-secondary group-hover:text-white transition-smooth" 
          />
          
          {/* Tooltip */}
          <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-primary text-white px-3 py-1 rounded-lg text-xs opacity-0 group-hover:opacity-100 transition-smooth pointer-events-none whitespace-nowrap">
            {link.platform}
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-primary"></div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;